import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { userService, UpdateUserData } from '../services/user-service';

export function useUsers() {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['users'],
        queryFn: userService.getUsers,
    });

    const createMutation = useMutation({
        mutationFn: userService.createUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            toast.success('Kullanıcı başarıyla oluşturuldu');
        },
        onError: (err: any) => {
            let message = 'Kullanıcı oluşturulurken bir hata oluştu';
            if (err.response?.data?.errors && Array.isArray(err.response.data.errors)) {
                message = err.response.data.errors.map((e: any) => e.msg).join(', ');
            } else if (err.response?.data?.message) {
                message = err.response.data.message;
            }
            toast.error(message);
        }
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }: { id: string, data: UpdateUserData }) => userService.updateUser(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            toast.success('Kullanıcı başarıyla güncellendi');
        },
        onError: (err: any) => {
            let message = 'Kullanıcı güncellenirken bir hata oluştu';
            if (err.response?.data?.errors && Array.isArray(err.response.data.errors)) {
                message = err.response.data.errors.map((e: any) => e.msg).join(', ');
            } else if (err.response?.data?.message) {
                message = err.response.data.message;
            }
            toast.error(message);
        }
    });

    const deleteMutation = useMutation({
        mutationFn: userService.deleteUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            toast.success('Kullanıcı başarıyla silindi');
        },
        onError: (err: any) => {
            const message = err.response?.data?.message || 'Kullanıcı silinirken bir hata oluştu';
            toast.error(message);
        }
    });

    return {
        ...query,
        createUser: createMutation.mutateAsync,
        updateUser: updateMutation.mutateAsync,
        deleteUser: deleteMutation.mutateAsync,
        isCreating: createMutation.isPending,
        isUpdating: updateMutation.isPending,
        isDeleting: deleteMutation.isPending,
    };
}
